import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const FeedbackModal = ({ encounter, isOpen, onClose, onSubmit }) => {
  const [ratings, setRatings] = useState({
    satisfaction: 5,
    communication: 5,
    fulfillment: 5
  });
  const [comments, setComments] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleRatingChange = (category, value) => {
    setRatings(prev => ({
      ...prev,
      [category]: value
    }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await onSubmit({
      encounterId: encounter?.id,
      ratings,
      comments
    });
    setIsSubmitting(false);
    onClose();
  };

  const RatingSlider = ({ label, value, onChange, icon }) => (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Icon name={icon} size={18} color="var(--color-primary)" />
          <label className="text-sm font-medium text-foreground">{label}</label>
        </div>
        <span className="text-lg font-semibold text-primary">{value}/10</span>
      </div>
      <input
        type="range"
        min="1"
        max="10"
        value={value}
        onChange={(e) => onChange(parseInt(e?.target?.value))}
        className="w-full h-2 bg-muted rounded-full appearance-none cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-primary [&::-webkit-slider-thumb]:cursor-pointer [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-primary [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:cursor-pointer"
      />
      <div className="flex justify-between text-xs text-muted-foreground">
        <span>Poor</span>
        <span>Excellent</span>
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 z-modal bg-background/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-md shadow-therapeutic-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 flex items-center justify-between">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
              Encounter Feedback
            </h2>
            <p className="text-sm text-muted-foreground mt-1">
              {encounter?.title} - {new Date(encounter.date)?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-muted transition-therapeutic"
            aria-label="Close feedback modal"
          >
            <Icon name="X" size={20} color="currentColor" />
          </button>
        </div>

        <div className="p-4 md:p-6 space-y-6">
          <div className="bg-primary/5 border border-primary/10 rounded-md p-4">
            <div className="flex items-start space-x-2">
              <Icon name="Info" size={18} color="var(--color-primary)" />
              <p className="text-sm text-muted-foreground">
                Your feedback is private and helps improve future encounter suggestions. Rate your experience honestly to help us better understand your relationship dynamics.
              </p>
            </div>
          </div>

          <div className="space-y-6">
            <RatingSlider
              label="Overall Satisfaction"
              value={ratings?.satisfaction}
              onChange={(value) => handleRatingChange('satisfaction', value)}
              icon="Heart"
            />

            <RatingSlider
              label="Communication Effectiveness"
              value={ratings?.communication}
              onChange={(value) => handleRatingChange('communication', value)}
              icon="MessageCircle"
            />

            <RatingSlider
              label="Desire Fulfillment"
              value={ratings?.fulfillment}
              onChange={(value) => handleRatingChange('fulfillment', value)}
              icon="Target"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Additional Comments (Optional)
            </label>
            <textarea
              value={comments}
              onChange={(e) => setComments(e?.target?.value)}
              placeholder="Share any thoughts about what worked well or could be improved..."
              rows={4}
              className="w-full px-4 py-3 bg-background border border-input rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background resize-none"
            />
          </div>

          <div className="flex flex-col sm:flex-row gap-3 pt-4">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              variant="default"
              iconName="Send"
              iconPosition="left"
              loading={isSubmitting}
              onClick={handleSubmit}
              className="flex-1"
            >
              Submit Feedback
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;